import { Component, Input } from '@angular/core';
import { GridService } from '../grid.service';
import Publication from '@app/publication';
import Section from '@app/section';

@Component({
  selector: 'app-content-panel',
  templateUrl: './content-panel.component.html',
  styleUrls: ['./content-panel.component.less']
})
export class ContentPanelComponent {
  @Input() activeSection: Section;
  @Input() publication: Publication;
  activeEditSection = 'content';
  constructor() { }

  activateEditSection(section: 'content' | 'layout' | 'settings' | 'styles') {
    this.activeEditSection = section;
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/content-panel.component.ts